import './kp-media-viewer-directories.less';
import {ngAsync, ngComponentCssClass} from 'shared/utils/ng-@decorators';
import type {Directory} from 'typings/portaro.be.types';
import type ReloaderService from '../../commons/services/reloader.service';
import type {DirectoryDataService} from '../../commons/data-services/directory.data-service';
import type FinishedResponseInteractionService from '../../commons/services/finished-response-interaction.service';

export abstract class KpMediaViewerDirectoriesComponentController implements KpMediaViewerDirectoriesComponentBindings {
    public directory: Directory;
    public currentDirectory: Directory;
    public editingEnabled: boolean;

    public abstract onSelect(locals: { $directory: Directory });

    /*@ngInject*/
    constructor(private directoryDataService: DirectoryDataService,
                private finishedResponseInteractionService: FinishedResponseInteractionService,
                private reloader: ReloaderService) {
    }

    @ngAsync()
    public async createSubdirectory() {
        if (!this.currentDirectory) {
            throw new Error('No parent directory to create directory');
        }

        try {
            const actionResponse = await this.directoryDataService.createSubdirectory(this.currentDirectory.id);
            await this.finishedResponseInteractionService.showSuccessResponseInToastIfPossible(actionResponse);
        } catch (exceptionResponse) {
            await this.finishedResponseInteractionService.showFailedResponseInModalWindow(exceptionResponse);
            throw exceptionResponse;
        }

        this.reloader.reload();
    }

    @ngAsync()
    public async editSelectedDirectory() {
        if (!this.currentDirectory) {
            throw new Error('No selected directory to edit');
        }

        try {
            const actionResponse = await this.directoryDataService.editDirectory(this.currentDirectory);
            await this.finishedResponseInteractionService.showSuccessResponseInToastIfPossible(actionResponse);
        } catch (exceptionResponse) {
            await this.finishedResponseInteractionService.showFailedResponseInModalWindow(exceptionResponse);
            throw exceptionResponse;
        }

        this.reloader.reload();
    }

    @ngAsync()
    public async deleteSelectedDirectory() {
        if (!this.currentDirectory) {
            throw new Error('No selected directory to delete');
        }

        try {
            const actionResponse = await this.directoryDataService.deleteDirectory(this.currentDirectory);
            await this.finishedResponseInteractionService.showSuccessResponseInToastIfPossible(actionResponse);
        } catch (exceptionResponse) {
            await this.finishedResponseInteractionService.showFailedResponseInModalWindow(exceptionResponse);
            throw exceptionResponse;
        }

        this.reloader.reload();
    }
}

/**
 * @ngdoc component
 * @name kpMediaViewerDirectories
 * @module portaro.media-viewer
 *
 * @param {Directory} directory Parent directory.
 * @param {Directory} currentDirectory Current selected directory.
 * @param {boolean} editingEnabled Enables creating directories.
 * @param {function()} onSelect Function triggered if some directory is selected.
 * @param {Directory} onSelect.$directory Selected directory.
 *
 * @description
 * Component for selecting directories in media viewer.
 */
// eslint-disable-next-line max-classes-per-file
export default class KpMediaViewerDirectoriesComponent {
    public static componentName = 'kpMediaViewerDirectories';

    @ngComponentCssClass('media-viewer-directories')
    public templateUrl = require('./kp-media-viewer-directories.tpl.pug');

    public bindings = {
        directory: '<',
        currentDirectory: '<',
        editingEnabled: '<',
        onSelect: '&'
    };

    public controller = KpMediaViewerDirectoriesComponentController;
}

interface KpMediaViewerDirectoriesComponentBindings {
    directory: Directory;
    currentDirectory: Directory;
    editingEnabled: boolean;

    onSelect(locals: { $directory: Directory });
}
